import { render, staticRenderFns } from "./DeleteProcedureCode.vue?vue&type=template&id=52b2bfcc"
import script from "./DeleteProcedureCode.vue?vue&type=script&lang=js"
export * from "./DeleteProcedureCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports